import Vue from 'vue';
import lodash from 'lodash';
import VueLodash from 'vue-lodash';

Vue.prototype._ = lodash;
Vue.use(VueLodash, lodash);